import axios from "axios";

export const axiosPlatform = () => supportPlatformResponse(supportAuthorization(prepareAxiosPlatform()));
export const axiosAuth = () => supportPlatformResponse(supportAuthorization(prepareAxiosAuth()));
export const axiosBilling = () => supportPlatformResponse(supportAuthorization(prepareAxiosBilling()));
export const axiosPaymentMatching = () => supportPlatformResponse(supportAuthorization(prepareAxiosPaymentMatching()));

export function prepareAxiosAuth() {
    return prepareAxiosWithBaseURL(process.env.REACT_APP_API_AUTH_BASE_URL);
}

export function prepareAxiosPlatform() {
    return prepareAxiosWithBaseURL(process.env.REACT_APP_API_BASE_URL);
}

export function prepareAxiosBilling() {
    return prepareAxiosWithBaseURL(process.env.REACT_APP_API_BILLING_BASE_URL);
}

export function prepareAxiosPaymentMatching() {
    return prepareAxiosWithBaseURL(process.env.REACT_APP_API_PMS_BASE_URL);
}

export function prepareAxiosWithBaseURL(baseURL) {
    return axios.create({
        baseURL: baseURL,
    });
}

export function supportAuthorization(instance) {
    let storedUser = localStorage.getItem("user");
    if (storedUser) {
        instance.defaults.headers.common["Authorization"] = "Bearer " + JSON.parse(storedUser).access_token;
    }
    return instance;
}

export function supportPlatformResponse(instance) {
    instance.interceptors.response.use(
        function (response) {
            try {
                if (
                    response.data &&
                    response.data.errorMessage &&
                    response.data.errorMessage.length > 0 &&
                    (!response.data.response || response.data.response === "")
                ) {
                    // console.log("Rejected Response")
                    return Promise.reject(response.data.errorMessage);
                } else if (
                    response.data.errorMessage !== "" &&
                    response.data.response &&
                    response.data.response !== ""
                ) {
                    return Promise.resolve(response.data);
                } else if (response.data.successMessage && response.data.successMessage !== "") {
                    return Promise.resolve(response.data);
                } else if (response.data.warningMessage && response.data.warningMessage !== "") {
                    return Promise.resolve(response.data);
                } else {
                    // console.log("Resolved result response")
                    return Promise.resolve(response.data.response);
                }
            } catch (error) {
                console.log(error);
                return Promise.reject(error);
            }
        },
        function (error) {
            if (error.response) {
                if (error.response.status === 503) {
                    return Promise.reject(error.response.statusText);
                }
            } else {
                return Promise.reject("Keine Verbindung zum Server möglich");
            }

            // Any status codes that falls outside the range of 2xx cause this function to trigger
            // Do something with response error
            return Promise.reject(error.message);
        }
    );
    return instance;
}
